var map = {
	"./decidim/avatar-multiuser.png": 89674,
	"./decidim/brands/facebook.svg": 57836,
	"./decidim/brands/google.svg": 41925,
	"./decidim/brands/twitter-x.svg": 98118,
	"./decidim/cc-badge.png": 61812,
	"./decidim/decidim-logo.svg": 61912,
	"./decidim/default-avatar.svg": 68800,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 380,
	"./decidim/icons.svg": 76827,
	"./decidim/pattern.png": 89692,
	"./decidim/placeholder-card-g.svg": 10201,
	"./decidim/placeholder-card-l.svg": 22098,
	"./decidim/placeholder.jpg": 24753,
	"./decidim/remixicon.symbol.svg": 28437,
	"./decidim/vendor/social-share-button/douban.svg": 63332,
	"./decidim/vendor/social-share-button/email.svg": 71585,
	"./decidim/vendor/social-share-button/facebook.svg": 1159,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 19129,
	"./decidim/vendor/social-share-button/hacker_news.svg": 13105,
	"./decidim/vendor/social-share-button/linkedin.svg": 6721,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 64162,
	"./decidim/vendor/social-share-button/pinterest.svg": 92503,
	"./decidim/vendor/social-share-button/reddit.svg": 37979,
	"./decidim/vendor/social-share-button/telegram.svg": 65662,
	"./decidim/vendor/social-share-button/tumblr.svg": 79677,
	"./decidim/vendor/social-share-button/twitter.svg": 88912,
	"./decidim/vendor/social-share-button/vkontakte.svg": 48030,
	"./decidim/vendor/social-share-button/wechat.svg": 72473,
	"./decidim/vendor/social-share-button/whatsapp.svg": 67233,
	"./decidim/vendor/social-share-button/x.svg": 15017,
	"./decidim/vendor/social-share-button/xing.svg": 82599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58803;